/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Propuesta_Valor_Portada_Informacion from "./SubComponentes/Propuesta_Valor_Portada_Informacion";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Portada_Informacion = ({item}) => {

    const {masSM} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
        >

            <Grid2 container size={12}
                   sx={{
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       backgroundImage: `linear-gradient(70deg, #000 20%, transparent 80%), url(${item.img})`,
                       backgroundSize: "cover",
                       backgroundPosition: "center",
                       overflowX: 'hidden',
                   }}
            >
                <Grid2 container size={12}
                       sx={{maxWidth: "1400px", px: 3}}>

                    <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                        <Grid2 container size={masSM ? 7 : 12}
                               sx={{py: 18, marginTop: 15}}>
                            <Propuesta_Valor_Portada_Informacion item={item}/>
                        </Grid2>

                        <Grid2 container size={masSM ? 6 : 12}>

                        </Grid2>
                    </Grid2>

                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Portada_Informacion;